import createIcon from './createIcon';

export default createIcon(require('./battery_alert.svg'));